import { AndroidLogo, AppBox, AppBoxShimmer, AppleLogo, Cell } from "src/components";
import { _ } from "src/services";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pages, PagesAction } from "src/store";

export const Download: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const pages: Pages = useSelector((state: any) => state.PagesState);

    //#endregion

    //#region effects

    useEffect(() => {

        if (!pages.apps.loaded) {
            dispatch(PagesAction.requestAppLinks());
        }

    }, [dispatch, pages.apps.loaded]);

    //#endregion

    const { android, ios, tv } = pages.apps.data;

    const renderLinks = () => (
        <>
            {android.length > 0 &&
                <>
                    <h4 className="subsection-title">
                        <AndroidLogo />
                        <span>{_("android")}</span>
                    </h4>
                    <div className="row">
                        {android.map((x, index) => (<AppBox {...x} key={index} />))}
                    </div>
                </>
            }
            {ios.length > 0 &&
                <>
                    <h4 className="subsection-title">
                        <AppleLogo />
                        <span>{_("ios")}</span>
                    </h4>
                    <div className="row">
                        {ios.map((x, index) => (<AppBox {...x} key={index} />))}
                    </div>
                </>
            }
            {tv.length > 0 &&
                <>
                    <h3 className="section-title">{_("smartTv")}</h3>
                    <div className="row">
                        {tv.map((x, index) => (<AppBox {...x} key={index} />))}
                    </div>
                </>
            }
        </>
    );

    const renderShimmer = () => (
        <>
            <h4 className="subsection-title">
                <AndroidLogo />
                <span>{_("android")}</span>
            </h4>
            <div className="row">
                {[...new Array(3)].map((x, index) => (<AppBoxShimmer key={index} />))}
            </div>
            <h4 className="subsection-title">
                <AppleLogo />
                <span>{_("ios")}</span>
            </h4>
            <div className="row">
                {[...new Array(3)].map((x, index) => (<AppBoxShimmer key={index} />))}
            </div>
            <h3 className="section-title">{_("smartTv")}</h3>
            <div className="row">
                {[...new Array(3)].map((x, index) => (<AppBoxShimmer key={index} />))}
            </div>
        </>
    );

    const renderContent = () => pages.apps.loaded ? renderLinks() : renderShimmer();

    return (
        <div className="page-download app-theme2">
            <div className="cover d-flex">
                <div className="container large-container d-flex">
                    <h1>
                        <Cell />
                        <span>{_("antenAppsTitle")}</span>
                    </h1>
                    <h2>{_("antenSlogan")}</h2>
                </div>
            </div>
            <div className="container large-container">
                <h3 className="section-title">{_("appList")}</h3>
                {renderContent()}
            </div>
        </div>
    );
};